<template>
  <div class="print popNumber popsize" id="printCon" @mouseover='isClose&&back()' @mouseout='isClose&&back()'>
    
    <div class="content">
      <!-- <embed
            width="900"
            height="800"
            id="pdfDocuments"
            type="application/pdf"
            ref="pdfDocument" /> -->
            <iframe hidden ref="iframePDF"></iframe>
        <div style="display:flex" class="top_btn">
            <button class="btn_newpatient btn" @click="back" v-show="printBtn" style="margin-left: 5px;" @mouseover='back' @mouseout='back' >取消/关闭打印</button>
        </div>
    </div>
    <div class="mask" v-show="printMask"></div>

  </div>
</template>
<script>
  import moment from 'moment';
  import _ from 'lodash';
  import {checkImage} from '../utils/imageAuto.js';
  import gql from "graphql-tag";
  import {printPDF} from "../utils/printPDF.js";
  import api from "../api.ts";
  export default {
    name: 'PrintReport',
    props: {
      data: {
        type: Object,
        default: () => {
          return {};
        }
      },
      data2: {
        type: Object,
        default: () => {
          return {};
        }
      },
      // 五种模态的报告图片数组包括镜下所见
      images: {
        type: Object,
        default: () => {
          return {};
        }
      },
      advise: {
        type: String,
        default: ""
      },
      id: Number,
      isHostory: Boolean,
      isDownLoad:Boolean
    },
    mixins: [printPDF],
    data() {
      return {
        descriptionArr: [],
        reportImages: {},
        age: 0,
        username: "",
        realname: "",
        showImgArr: [],
        initialTime:-30610253143000, // 初始时间1000-01-01 00:00:00
        printMask:false,
      }
    },
    mounted() {
      this.PrintSubmit();
    },
    methods: {
      back() {
        this.printMask=false;
        this.$emit("message", {type: 'back'});
      },
      async PrintSubmit() {
        try {
          await this.postInfo();
          if(this.isHostory) {
            await this.PrintTimeSubmit();
          }
        } catch(error) {
          
          this.$message.error(error.message.split(":")[1]);
        }
      },
      async PrintTimeSubmit() {// 提交照片打印时间
        let newgql = "";
        if (this.showImgArr.length > 0) {
          let nowTime = moment().format("YYYY-MM-DD HH:mm:ss");
          for (let i = 0; i < this.showImgArr.length; i++) {
            newgql += `m${i}:modifyImage(id:${this.showImgArr[i].id},print_time:"${nowTime}"),`
          }
          let res = await this.$apollo.mutate({
            mutation: gql`mutation{${newgql}}`
          });
        }
      }
    },
    async created() {
      this.realname = this.$store.state.me;
      this.realname = localStorage.getItem("me");
      let current = Number(moment(this.data.birthday).format("YYYYMMDD").substring(0, 4));
      let end = Number(moment().format("YYYYMMDD").substring(0, 4));
      this.age = end - current;
      this.username = sessionStorage.getItem("username");
    },
    computed: {},
    watch: {
      images: {
        async handler(newval, oldval) {
          this.images = newval;
          let self = this;
          if (!_.isEmpty(this.images)) {
            if (this.isHostory) {
              for (let key in this.images) {
                if (key === "bc" || key === "bl" || key === "ct" || key === "general" || key === "skin") {
                  let tempImg = _.cloneDeep(self.images[key].imgs);
                  for (let j = 0; j < self.showImgArr.length; j++) {
                    self.showImgArr[j].src = self.showImgArr[j].src.replace(api.server+"/skin_images/", "skin_images/");
                    self.showImgArr[j].src = self.showImgArr[j].src.split("?")[0];
                  }
                  self.showImgArr.push(...tempImg);
                }
              }
            } else {
              for (let key in this.images) {
                if (key === "bc" || key === "bl" || key === "ct" || key === "general" || key === "skin") {
                  let tempImg = _.cloneDeep(self.images[key].imgs);
                  for (let j = 0; j < self.showImgArr.length; j++) {
                    self.showImgArr[j].src = self.showImgArr[j].src.replace(api.server+"/skin_images/", "skin_images/thumbnails/");
                  }
                  self.showImgArr.push(...tempImg);
                }
              }
              _.remove(self.showImgArr, (n) => {
                return n.print_time === self.initialTime;
              });
            }

          }
        },
        deep: true,
        immediate: true
      }

    }
  };
</script>
<style scoped lang="less">
  

  

  #printCon {
    width: 100%;
    height:100%;
    margin: 0 auto;
    box-sizing: border-box;
  }


  .content {
    width: 100%;
    box-sizing: border-box;
    height:80%;
    display: block;
    background: rgba(255,255,255,0);
    flex-shrink: 0;
    position: relative;
    text-align: left;

  }

  .top_btn {
    width: 100%;
    justify-content: center;
    align-items:center;
    button{
        position: absolute;
        z-index:10;
      margin-top:300px;
    }
  }
   .mask {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
</style>


